import React from "react"
import { Link } from "gatsby"

const Breadcrumb = ({ title, category }) => {
  return (
    <div id="breadcrumb" className="p-breadcrumb">
      <ol className="p-breadcrumb__list l-container">
        <li className="p-breadcrumb__item">
          <Link to="/" className="p-breadcrumb__text">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              className="arkhe-svg-home"
              width="1em"
              height="1em"
              viewBox="0 0 40 40"
              role="img"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M16.2,36.3v-7.8h7.8v7.8h9.8V20.7H37c0.9,0,1.3-1.1,0.5-1.7L21.3,4.2c-0.7-0.7-1.9-0.7-2.6,0L2.3,18.9 c-0.7,0.5-0.3,1.7,0.5,1.7h3.3v15.7C6.2,36.3,16.2,36.3,16.2,36.3z" />
            </svg>{" "}
            <span>ホーム</span>
          </Link>
        </li>
        {category && (
          <li className="p-breadcrumb__item">
            <Link
              to={`/category/${category.slug}/`}
              className="p-breadcrumb__text"
            >
              <span>{category.title}</span>
            </Link>
          </li>
        )}
        <li className="p-breadcrumb__item">
          <span className="p-breadcrumb__text u-color-thin">{title}</span>
        </li>
      </ol>
    </div>
  )
}

export default Breadcrumb
